var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-switch"},[_c('v-switch',_vm._b({attrs:{"input-value":_vm.inputValue,"ripple":false,"inset":"","hide-details":""},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-switch',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }